const localNameLookup: Readonly<Record<string, string|undefined>> = {
	en: "English",
	id: "Bahasa Indonesia",
};

export function toLocalName(code: string) {
	return localNameLookup[code];
}

const englishNameLookup: Readonly<Record<string, string|undefined>> = {
	en: "English",
	id: "Indonesian",
};

export function toEnglishName(code: string) {
	return englishNameLookup[code];
}

export function toDefaultFormat(code: string) {
	const localName = toLocalName(code);
	const englishName = toEnglishName(code);

	if (localName === undefined) {
		console.error(`Language code ${code} is unrecognized.`);
		return code;
	}

	let result = localName;
	if (code !== "en" && englishName !== undefined) {
		result += ` (${englishName})`;
	}

	return result;
}

const countryLookup: Readonly<Record<string, string|undefined>> = {
	en: "us",
	id: "id",
};

export function toCountry(code: string) {
	return countryLookup[code];
}